// extracted by mini-css-extract-plugin
export const event_venue_link = "Events-module--event_venue_link--MvgCL";
export const events = "Events-module--events--2zFfL";
export const header = "Events-module--header--MYyc2";
export const featured_event = "Events-module--featured_event--3oMV_";
export const upcoming_events = "Events-module--upcoming_events--1-7cy";
export const event_inner_content = "Events-module--event_inner_content--1p7bu";
export const featured_event_img = "Events-module--featured_event_img--oHmT-";
export const previous_events = "Events-module--previous_events--2yjgU";
export const previous_events_column = "Events-module--previous_events_column--3MIhc";
export const column_title = "Events-module--column_title--2XHeW";
export const websites_feature = "Events-module--websites_feature--ZDebh";
export const websites_img = "Events-module--websites_img--2IL_q";
export const bouncy = "Events-module--bouncy--1H0lt";
export const pop = "Events-module--pop--ZhoJh";